import { Button, Chip, Modal, ModalBody, ModalFooter, ModalHeader, Text } from '@change/ds-core-ui';
import { ExpandIcon } from '@change/ds-icons';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { TopicsFilter } from '#src/app/pages/searchV2/shared/components';

import { ClearTopicsFilter } from './components/ClearTopicsFilter';
import { useTopicsMobileButton } from './hooks/useTopicsMobileButton';

export const TopicsMobileButton: React.FC = () => {
	const { translate } = useI18n();
	const {
		data: { nOfFilters },
	} = useTopicsMobileButton();

	return (
		<div className="relative">
			<Modal
				onClose={() => {}}
				closeButtonAriaLabel={translate('corgi.components.modal.close_button')}
				trigger={
					<Chip
						as="button"
						forceInteractive
						trailingIcon={nOfFilters === 0 ? <ExpandIcon /> : undefined}
						active={nOfFilters > 0}
						size="small"
						count={nOfFilters > 0 ? nOfFilters : undefined}
					>
						{nOfFilters > 1 ? (
							<Translate value="corgi.search.filters.topic.title" />
						) : (
							<Translate value="corgi.search.filters.topic.title_chip" />
						)}
					</Chip>
				}
			>
				<ModalHeader
					title={
						<Text variant="heading" size="small">
							<Translate value="corgi.search.filters.topic.title" />
						</Text>
					}
				/>

				<ModalBody className="min-h-[50vh]">
					<TopicsFilter trackingContext="topic_filter" />
				</ModalBody>

				<ModalFooter>
					{({ close }) => (
						<>
							<Button variant="primary" onClick={close} className="w-full md:w-auto">
								<Translate value="corgi.search.filters.view_results" />
							</Button>
							<ClearTopicsFilter />
						</>
					)}
				</ModalFooter>
			</Modal>
		</div>
	);
};
